class ApplicationJoinForm {
    static init($context = null) {
        var selector = "[data-application-type='join']";
        let $containers = $context ? $context.find(selector) : $(selector);

        $containers.each(function (index, element) {
            if ($(element).data('join_form_instance')) return;
            $(element).data('join_form_instance', new ApplicationJoinForm(element))
        });
    }

    loadTimeout = null

    constructor(element) {
        this.version = '0.0.1'
        this.element = element;
        this.$element = $(element);
        this.$actionsWrap = this.$element.find('[data-validation-status]');
        this.$element.on('ajax-form.done', function (e, result) {
            this.loadLoadVerificationState();
        }.bind(this))

        this.loadLoadVerificationState();


    }
    basePath() {
        if ($('base').length) {
            return '';
        } else {
            return '/'
        }
    }

    loadLoadVerificationState(){
        clearTimeout(this.loadTimeout)
        this.loadTimeout = setTimeout(() => {
            this.$actionsWrap.html('<div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div>')


            $.ajax(`${this.basePath()}api/applications/application_verification_state`, {
                data: {
                    application: this.$element.closest('form').find('[name="id"]').val(),
                }
            }).done(function (r) {
                if(r.badge){
                    this.$actionsWrap.html(r.badge);
                }else{
                    this.$actionsWrap.html('')
                }
            }.bind(this))
        }, 1000);
    }
}


if (typeof module === "object" && typeof module.exports === "object"){
    ApplicationJoinForm.init()
    //node modules support
    module.exports = ApplicationJoinForm;
}else{
    $(function(){
        ApplicationJoinForm.init()
    });
}